import { ConfirmUnsaved } from "components/ConfirmDialog/ConfirmUnsaved";
import { HookFormDebug } from "components/FormDebug/HookFormDebug";
import { EditFormFooter } from "components/Forms/EditFormFooter";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useEditBoardProperties, useTranslations } from "providers";
import React from "react";

import { EditBoardPropertiesForm } from "./EditBoardPropertiesForm";

export const EditBoardPropertiesPanel: React.FC = () => {
  const i18n = useTranslations();
  const {
    isDirty,
    isValid,
    isSubmittable,
    isSubmitting,
    confirmUnsaved,
    setConfirmUnsaved,
    getPatch,
    handleSave,
    handleClose,
    form,
  } = useEditBoardProperties();

  const saveButtonDisabled = !isDirty || !isValid;

  return (
    <>
      <SlidingPanel
        isOpen={true}
        onCancel={() => handleClose(true)}
        onClose={() => handleClose()}
        onSave={() => handleSave()}
        panelClassName=""
        panelContainerClassName=""
        saveButtonDisabled={saveButtonDisabled}
        isSubmitting={isSubmitting}
        header={<h1>{i18n.EditBoardPanel_Header}</h1>}
        footer={
          <EditFormFooter
            onCancel={() => handleClose(true)}
            onSubmit={() => handleSave()}
            isSubmitting={isSubmitting}
            isDirty={isDirty}
          />
        }
        debugContent={
          <HookFormDebug
            watch={() => getPatch(form.watch())}
            formState={form.formState}
            isSubmitting={isSubmitting}
            isSubmittable={isSubmittable}
          />
        }
      >
        <EditBoardPropertiesForm />
      </SlidingPanel>

      <ConfirmUnsaved
        onAccept={() => handleClose(true)}
        isOpen={confirmUnsaved}
        setIsOpen={setConfirmUnsaved}
        onCancel={() => setConfirmUnsaved(false)}
      />
    </>
  );
};
